export const WHATSAPP_NUMBER = "254758608440";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi KeDe-Ceaning! I'd like a free quote for cleaning / gardening in Shanzu."
)}`;
export const PHONE_DISPLAY = "+254 758 608 440";
export const PHONE_LINK = "tel:+254758608440";

export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -84, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
